export class Category {
    constructor() {
        this.selected = false;
        this.id = null;
        this.name = null;
        this.description = null;
        this.quantity = null;
        this.position = null;
        this.image = null;
        this.imageFile = null;
        this.imagePreview = null;
    }

    map(category) {
        if(category.id || category.id === 0) this.id = category.id;

        if (category.name) this.name = category.name;
        else this.name = '';

        if (category.description) this.description = category.description;
        else this.description = '';

        if (category.quantity) this.quantity = category.quantity;
        else this.quantity = '';

        if (category.position >= 0) this.position = category.position;
        else this.position = '';

        if (category.image) this.image = category.image;
        else this.image = '';

        return this;
    }

    update(category) {
        if (category.id) this.id = category.id;
        if (category.name) this.name = category.name;
        if (category.description) this.description = category.description;
        if (category.quantity) this.quantity = category.quantity;
        if (category.position) this.position = category.position;
        if (category.imageFile) this.imageFile = category.imageFile;
        if (category.imagePreview) this.imagePreview = category.imagePreview;

        return this;
    }

    uploadImage(data) {
        this.imageFile = data.file;
        this.imagePreview = data.preview;

        return this;
    }

    setName(name) {
        this.name = name
    }
}